import { jt, t } from "ttag";

import goalPlanImage from "@/assets/onboarding/goal-plan.webp";
import weightDroppedImageEs from "@/assets/onboarding/weight-dropped-spanish.webp";
import weightDroppedImageEn from "@/assets/onboarding/weight-dropped.webp";
import { AVAILABLE_LANGUAGE } from "@/shared/models";
import { useSettingsStore } from "@/shared/stores/use-settings-store";
import { Heading } from "@/shared/ui";

export const WeightLossGoalPlan = () => {
  const language = useSettingsStore((state) => state.language);

  const weightDroppedImage =
    language === AVAILABLE_LANGUAGE.ES
      ? weightDroppedImageEs
      : weightDroppedImageEn;

  const goal = (
    <span key="goal" className="text-secondary-500">
      {t`goal`}
    </span>
  );

  const medicalProfessionals = (
    <span key="medical-professionals" className="font-semibold">
      {t`medical professionals`}
    </span>
  );

  return (
    <>
      <div className="flex">
        <div className="flex flex-col gap-6">
          <Heading color="primary" weight="medium">
            {jt`Your ${goal} plan is`}
          </Heading>

          <ul className="flex list-inside list-disc flex-col gap-4 text-lg text-primary-950 marker:text-secondary-500">
            <li>
              {t`Reset your metabolic "set point" so your body naturally supports a healthier weight`}
            </li>
            <li>
              {t`Build sustainable habits with medical guidance and ongoing support`}
            </li>
            <li>{t`Look and feel healthier, with results that last`}</li>
          </ul>

          <div className="flex flex-col gap-4">
            <Heading size="large" level={2} color="secondary">
              {t`Your plan`}
            </Heading>

            <p className="text-lg text-primary-950">
              {jt`You'll have everything you need to support meaningful, sustainable weight loss — guided by ${medicalProfessionals} and focused on long-term results, not quick fixes.`}
            </p>
          </div>
        </div>

        <img
          alt="goal-plan"
          src={goalPlanImage}
          className="hidden h-105 w-36 md:block"
        />
      </div>

      <img
        alt={t`Weight loss progress`}
        src={weightDroppedImage}
        className="w-full"
      />
    </>
  );
};
